import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import { authStore } from './auth'
import { keys } from 'lodash'

export const aiStore = defineStore('ai', {
  id: 'ai',
  state: () => ({
    loading: {
      aiPrompt: false,
      aiList: false,  
      aiResponse: false
    },
    aiList: [],
    aiPrompt: null,
    aiResponse: null,
    aiKeys: [
      '[[VIN_YR_MAKE_MODEL]]',
      '[[VIN]]',
      '[[REPAIR_LINES]]',
      '[[BMS_EMS]]',
      '[[DECODED_VIN_INFO]]',
      '[[ADAS_MATRIX]]'
    ]
  }),
  //   aiKeys: [
  //     '[[VIN_YR_MAKE_MODEL]]',
  //     '[[VIN]]',
  //     '[[BMS_EMS]]',
  //     '[[DECODED_VIN_INFO]]',
  //     '[[ADAS_MATRIX]]'
  //   ]
  // }),
  actions: {
    resetPrompt() {
      this.aiPrompt = null
      this.aiResponse = null
      this.loading.aiPrompt = false
      this.loading.aiResponse = false
    },
    async aiRequest(data) {
      this.loading.aiResponse = true
      this.aiResponse = await api.post(`ai/aiRequest`, data)
      this.loading.aiResponse = false
      return this.aiResponse
    },
    async getAi(data) {
      this.aiPrompt = null
      this.aiList = []
      this.loading.aiPrompt = false
      this.loading.aiList = false
      if (data.ai === null && data.firm !== null) {
        this.loading.aiList = true
        this.aiList = await api.get(`ai/ai?firm=${data.firm}`)
        this.loading.aiList = false
        console.log('Got AI List:', this.aiList)
      } else {
        this.loading.aiPrompt = true
        this.aiPrompt = await api.get(`ai/ai?ai=${data.ai}&firm=${data.firm}&name=${data.name}`)
        this.loading.aiPrompt = false
        console.log('Got AI Prompt:', this.aiPrompt)
      }
    },
    async saveAiPrompt(data) {
      const r = await api.post(`ai/saveAi`, data)
      return r
    },
    async deleteAiPrompt(ai) {
      const r = await api.delete(`ai/deleteAi?ai=${ai}`)
      return r
    }
  }
})